import React, { useState, useEffect, FC } from "react";
import { useHistory } from "react-router";
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { useNavModel } from "../../../../model/navModel";
import { useDataCatalogModel } from "../dataCatalogModel";
import { DetailType } from "../dataCatalogTypes"

const CatalogForm = () => {
    const [form] = Form.useForm();
    const { selectedNavId,addNav, closeNav, getSelectedNavState,replaceNav } = useNavModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { selectedRow, addParam, updataEditParam, updataData, insertData, updataAddParam } = useDataCatalogModel()
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow)
        }
    }, [])
    const onFinish = (values: any) => {
        if (mode == DetailType.add) {
            insertData(values).then(res=> res&& close())
        } else if (mode == DetailType.edit) {
            updataData(values).then(res=> res&& close())
        }
    }
    const reset =async () => {
        form.resetFields()
        form.setFieldsValue({code:selectedRow.code})
    }
    const close = () => {
        replaceNav(selectedNavId, "1-1")
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    const items = [
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "目录编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: pageParams.mode == DetailType.edit,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "目录名称",
            labelCol: { span: 6 },
            fieldName: "tableName",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "默认数据分支编码",
            labelCol: { span: 6 },
            fieldName: "defaultBranchCode",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            valuePropName: "checked",
            fieldLabel: "远程新增",
            labelCol: { span: 6 },
            fieldName: "allowRemoteInsert",
            checkedChildren: "允许",
            unCheckedChildren: "不允许"
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            valuePropName: "checked",
            fieldLabel: "远程更新",
            labelCol: { span: 6 },
            fieldName: "allowRemoteUpdate",
            checkedChildren: "允许",
            unCheckedChildren: "不允许",
        },
        // {
        //     type: FormItemTypeEnum.Switch,
        //     span: 8,
        //     valuePropName: "checked",
        //     fieldLabel: "远程删除",
        //     labelCol: { span: 6 },
        //     fieldName: "allowRemoteDelete",
        //     checkedChildren: "允许",
        //     unCheckedChildren: "不允许"
        // },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            valuePropName: "checked",
            fieldLabel: "多分支",
            labelCol: { span: 6 },
            fieldName: "allowMultiBranch",
            checkedChildren: "允许",
            unCheckedChildren: "不允许"
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            valuePropName: "checked",
            fieldLabel: "远程查询",
            labelCol: { span: 6 },
            fieldName: "allowRemoteSelect",
            checkedChildren: "允许",
            unCheckedChildren: "不允许"
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            valuePropName: "checked",
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "status",
            checkedChildren: "审核",
            unCheckedChildren: "未审核"
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "备注",
            labelCol: { span: 6 },
            fieldName: "note",
        },
    ]
    const setTitle = (tit: string) => {
        switch (tit) {
            case DetailType.add: return "新增";
            case DetailType.edit: return "编辑";
            case DetailType.look: return "查看";
            default: return false;
        }
    }
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}数据目录</div>

    return (<Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>)
}
export default CatalogForm